export const PAPERS = {
  letter: { label: 'Letter', size: '8.5 × 11 in', w: 11, h: 8.5 },
  tabloid: { label: 'Tabloid', size: '11 × 17 in', w: 17, h: 11 },
};

export const MARGIN_IN = 0.4;
export const PT_PX = 96 / 72;

export function pageBox(paper, orientation) {
  const p = PAPERS[paper] || PAPERS.letter;
  const land = orientation !== 'portrait';
  const wIn = land ? p.w : p.h;
  const hIn = land ? p.h : p.w;
  return {
    paper: PAPERS[paper] ? paper : 'letter',
    orientation: land ? 'landscape' : 'portrait',
    wIn, hIn, w: wIn * 72, h: hIn * 72, margin: MARGIN_IN * 72,
  };
}
